module.exports = __webpack_public_path__ + "static/media/chat_function.ec23fb03.png";